import {
    SET_MACRO_INDICATORS,
    ADD_MACRO_INDICATOR,
    UPDATE_MACRO_INDICATOR,
    DELETE_MACRO_INDICATOR,
    CLEAR_MACRO_INDICATORS,
    SET_FUEL_DATA,
    ADD_FUEL,
    UPDATE_FUEL,
    DELETE_FUEL,
    CLEAR_FUEL_DATA,
} from "../../actions/actiontypes";

const initialState = {
    macroIndicators: [], // Start empty since we'll fetch from API
    fuelData: [],
    loading: false
};

const liveFeedReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MACRO_INDICATORS:
            return {
                ...state,
                macroIndicators: action.payload,
                loading: false
            };
        case ADD_MACRO_INDICATOR:
            return {
                ...state,
                macroIndicators: [...state.macroIndicators, action.payload]
            };
        case UPDATE_MACRO_INDICATOR:
            return {
                ...state,
                macroIndicators: state.macroIndicators.map(indicator =>
                    indicator.uuid === action.payload.uuid ? action.payload : indicator
                )
            };
        case DELETE_MACRO_INDICATOR:
            return {
                ...state,
                macroIndicators: state.macroIndicators.filter(
                    indicator => indicator.uuid !== action.payload.uuid
                )
            };
        case CLEAR_MACRO_INDICATORS:
            return {
                ...state,
                macroIndicators: []
            };
        case SET_FUEL_DATA:
            return {
                ...state,
                fuelData: action.payload
            };

        case ADD_FUEL:
            return {
                ...state,
                fuelData: [...state.fuelData, action.payload]
            };

        case UPDATE_FUEL:
            return {
                ...state,
                fuelData: state.fuelData.map(fuel =>
                    fuel.uuid === action.payload.uuid ? action.payload : fuel
                )
            };

        case DELETE_FUEL:
            return {
                ...state,
                fuelData: state.fuelData.filter(fuel => fuel.uuid !== action.payload.uuid)
            };

        case CLEAR_FUEL_DATA:
            return {
                ...state,
                fuelData: []
            };
        default:
            return state;
    }
};

export default liveFeedReducer;